var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrahp5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 111,
    viewBox: "0 0 130 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_176_3490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.216 91H24.6118C22.0651 91 20 89.1335 20 86.8307V24.1693C20 21.867 22.0646 20 24.6118 20H189.216C191.762 20 193.828 21.8665 193.828 24.1693V86.8307C193.827 89.1335 191.762 91 189.216 91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.176 32.6899H30.049C29.8982 32.6899 29.7758 32.5675 29.7758 32.4167C29.7758 32.2659 29.8982 32.1436 30.049 32.1436H183.176C183.327 32.1436 183.449 32.2659 183.449 32.4167C183.449 32.5675 183.327 32.6899 183.176 32.6899Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.176 44.687H30.0491C29.8983 44.687 29.7759 44.5646 29.7759 44.4138C29.7759 44.263 29.8983 44.1406 30.0491 44.1406H183.176C183.327 44.1406 183.449 44.263 183.449 44.4138C183.449 44.5652 183.327 44.687 183.176 44.687Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.176 56.6841H30.0491C29.8983 56.6841 29.7759 56.5617 29.7759 56.4109C29.7759 56.2601 29.8983 56.1377 30.0491 56.1377H183.176C183.327 56.1377 183.449 56.2601 183.449 56.4109C183.449 56.5617 183.327 56.6841 183.176 56.6841Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.176 68.6821H30.0491C29.8983 68.6821 29.7759 68.5597 29.7759 68.4089C29.7759 68.2581 29.8983 68.1357 30.0491 68.1357H183.176C183.327 68.1357 183.449 68.2581 183.449 68.4089C183.449 68.5603 183.327 68.6821 183.176 68.6821Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.176 80.6792H30.0491C29.8983 80.6792 29.7759 80.5568 29.7759 80.406C29.7759 80.2552 29.8983 80.1328 30.0491 80.1328H183.176C183.327 80.1328 183.449 80.2552 183.449 80.406C183.449 80.5573 183.327 80.6792 183.176 80.6792Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.289 38.0624L157.101 40.219C153.937 40.4796 150.752 40.2414 147.662 39.5131L127.348 34.7252C122.935 33.6854 118.346 33.6483 113.917 34.6175L91.1677 39.5956C86.7377 40.5649 82.147 40.5277 77.7334 39.4869L66.5649 36.8528C59.4194 35.1672 51.9051 36.1332 45.4179 39.5715L30.0494 47.7158V80.4072H183.176L183.289 38.0624Z",
    fill: "#2769DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.289 50.1728L162.674 46.5956C155.97 45.4324 149.071 46.559 143.086 49.793L132.668 55.4224C125.023 59.5535 115.973 60.2043 107.815 57.209L97.9728 53.5947C89.4095 50.4503 79.8856 51.3305 72.0434 55.9911L64.7247 60.3408C58.7441 63.895 51.7226 65.2839 44.8399 64.2731L30.0489 62.1018V80.4054H183.175L183.289 50.1728Z",
    fill: "#2359B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.289 66.4731L157.784 61.7475C154.175 61.0787 150.474 61.0711 146.863 61.7256L124.914 65.7005C122.082 66.2136 119.192 66.3201 116.329 66.018L92.0698 63.4549C87.0611 62.9255 81.9995 63.6532 77.3422 65.5716L65.0749 70.625C58.8555 73.187 51.9602 73.6071 45.4758 71.8194L30.0489 67.5653V80.4057H183.175L183.289 66.4731Z",
    fill: "#1B386B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_176_3490",
    x: 0,
    y: 0,
    width: 213.828,
    height: 111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_176_3490"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_176_3490",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrahp5);
export default __webpack_public_path__ + "static/media/grahp5.72a6444f3fcff1764370d6270ecb5869.svg";
export { ForwardRef as ReactComponent };